import * as React from 'react';
import { Slider } from '~/components/ui/slider';
import { useDragHistory } from '~/store/useDragHistory';

type SliderProps = React.ComponentProps<typeof Slider>;

export function HistoryGroupedSlider(props: SliderProps) {
  const beginDrag = useDragHistory();
  const endRef = React.useRef<(() => void) | null>(null);

  // Resume temporal store if the component unmounts mid-drag (e.g. panel close).
  React.useEffect(() => () => endRef.current?.(), []);

  return (
    <Slider
      {...props}
      onPointerDown={(e) => {
        endRef.current = beginDrag();
        props.onPointerDown?.(e);
      }}
      onPointerUp={(e) => {
        endRef.current?.();
        endRef.current = null;
        props.onPointerUp?.(e);
      }}
      onPointerCancel={(e) => {
        endRef.current?.();
        endRef.current = null;
        props.onPointerCancel?.(e);
      }}
    />
  );
}
